"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _require = require('../../../commons/httpClient'),
  httpClient = _require.httpClient;
var store = require('../../../../../../../config/store');
var helpers = require('on4u_adyen_SFRA/adyen/checkout/helpers');
var _require2 = require('../../../../../../../config/constants'),
  GOOGLE_PAY = _require2.GOOGLE_PAY,
  GOOGLE_PAY_CALLBACK_TRIGGERS = _require2.GOOGLE_PAY_CALLBACK_TRIGGERS;
var _require3 = require('../../initializeCheckout'),
  initializeCheckout = _require3.initializeCheckout;
var _require4 = require('../../../commons'),
  createTemporaryBasket = _require4.createTemporaryBasket;
// BYL: upper bound for the Google Pay onPaymentDataChanged callback. Google's
// own deadline is undocumented, so this has to answer well before any plausible
// one -- returning a shipping error beats letting Google abort the sheet with
// CALLBACK_TIMED_OUT. With a single request per callback (measured 0.5-1.4s)
// there is ample margin.
var SHIPPING_CALLBACK_DEADLINE_MS = 6000;
var GooglePay = /*#__PURE__*/_createClass(function GooglePay(config, applicationInfo, adyenTranslations, isExpressPdp, initialAmount) {
  var _this = this;
  _classCallCheck(this, GooglePay);
  _defineProperty(this, "getShippingMethods", /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(shippingAddress) {
      var requestBody;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            requestBody = {
              paymentMethodType: GOOGLE_PAY,
              isExpressPdp: _this.isExpressPdp
            };
            if (shippingAddress) {
              requestBody.address = {
                city: shippingAddress.locality,
                country: shippingAddress.country,
                countryCode: shippingAddress.countryCode,
                stateCode: shippingAddress.administrativeArea,
                postalCode: shippingAddress.postalCode
              };
            }
            return _context.a(2, httpClient({
              method: 'POST',
              url: _this.shippingMethodsUrl,
              data: {
                data: JSON.stringify(requestBody)
              }
            }));
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
  _defineProperty(this, "selectShippingMethod", /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_ref2) {
      var shipmentUUID, ID, requestBody;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            shipmentUUID = _ref2.shipmentUUID, ID = _ref2.ID;
            requestBody = {
              paymentMethodType: GOOGLE_PAY,
              shipmentUUID: shipmentUUID,
              methodID: ID,
              isExpressPdp: _this.isExpressPdp
            };
            return _context2.a(2, httpClient({
              method: 'POST',
              url: _this.selectShippingMethodUrl,
              data: {
                data: JSON.stringify(requestBody)
              }
            }));
        }
      }, _callee2);
    }));
    return function (_x2) {
      return _ref3.apply(this, arguments);
    };
  }());
  // BYL: per-request timings, reported only when a callback fails. The gap
  // between requests is invisible in the network waterfall and is where a slow
  // cart page (recommendations, analytics, the 6-connection-per-host limit)
  // eats the callback budget.
  _defineProperty(this, "timed", function (name, request) {
    var from = new Date().getTime();
    _this.callTimings.push(name + ':pending');
    var index = _this.callTimings.length - 1;
    return request.then(function (response) {
      _this.callTimings[index] = name + ':' + (new Date().getTime() - from) + 'ms';
      return response;
    }, function (error) {
      _this.callTimings[index] = name + ':failed after ' + (new Date().getTime() - from) + 'ms';
      throw error;
    });
  });
  _defineProperty(this, "unserviceable", function (intent) {
    // Resolving with this closes the sheet on the shopper, so it is worth a
    // line even though it is a valid answer for Google.
    // eslint-disable-next-line no-console
    console.error('[GooglePayExpress] no shipping available for', intent, _this.callTimings.join(' | '));
    // BYL: drop the cached shipment. onShippingOptionChange skips the method
    // lookup when it has one, and that lookup is where the address gets
    // validated -- so a shipping-option change right after a refusal would be
    // served from the cache, against the address just refused (SF-18457).
    _this.shipmentUUID = null;
    return {
      error: {
        reason: 'SHIPPING_ADDRESS_UNSERVICEABLE',
        message: GooglePay.getUnserviceableMessage(),
        intent: intent
      },
      newTransactionInfo: GooglePay.getBaseTransactionInfo(_this.amount)
    };
  });
  // BYL: one round trip per callback. Every extra request is serialized on the
  // same SFCC session and recalculates the basket, and the pair used to blow
  // through Google's callback deadline on slower instances.
  _defineProperty(this, "onShippingAddressChange", function (shippingAddress) {
    return _this.timed('shippingMethods', _this.getShippingMethods(shippingAddress)).then(function (shippingMethodsData) {
      var methods = shippingMethodsData && shippingMethodsData.shippingMethods;
      if (!methods || !methods.length) {
        return _this.unserviceable('SHIPPING_ADDRESS');
      }
      var selectedShippingMethod = methods[0];
      _this.shipmentUUID = selectedShippingMethod.shipmentUUID || _this.shipmentUUID;
      // The endpoint already selected this method and recalculated the basket,
      // so its total is authoritative. Older deployments don't return it.
      if (shippingMethodsData.grandTotalAmount) {
        return {
          newShippingOptionParameters: GooglePay.getShippingOptionsParameters(selectedShippingMethod, shippingMethodsData),
          newTransactionInfo: GooglePay.getTransactionInfo(shippingMethodsData)
        };
      }
      return _this.timed('selectShippingMethod', _this.selectShippingMethod(selectedShippingMethod)).then(function (newCalculation) {
        if (!newCalculation || !newCalculation.grandTotalAmount) {
          return _this.unserviceable('SHIPPING_ADDRESS');
        }
        return {
          newShippingOptionParameters: GooglePay.getShippingOptionsParameters(selectedShippingMethod, shippingMethodsData),
          newTransactionInfo: GooglePay.getTransactionInfo(newCalculation)
        };
      });
    });
  });
  _defineProperty(this, "onShippingOptionChange", function (shippingAddress, shippingOptionData) {
    // The shipment UUID cached on the first callback is all SelectShippingMethod
    // needs, so the method list doesn't have to be fetched again.
    var selected = _this.shipmentUUID ? Promise.resolve({
      shipmentUUID: _this.shipmentUUID,
      ID: shippingOptionData.id
    }) : _this.timed('shippingMethods', _this.getShippingMethods(shippingAddress)).then(function (shippingMethodsData) {
      var methods = shippingMethodsData && shippingMethodsData.shippingMethods ? shippingMethodsData.shippingMethods : [];
      var match = null;
      methods.forEach(function (sm) {
        if (sm.ID === shippingOptionData.id) {
          match = sm;
        }
      });
      return match;
    });
    return selected.then(function (shippingMethod) {
      if (!shippingMethod) {
        return _this.unserviceable('SHIPPING_OPTION');
      }
      return _this.timed('selectShippingMethod', _this.selectShippingMethod(shippingMethod)).then(function (newCalculation) {
        if (!newCalculation || !newCalculation.grandTotalAmount) {
          return _this.unserviceable('SHIPPING_OPTION');
        }
        return {
          newTransactionInfo: GooglePay.getTransactionInfo(newCalculation)
        };
      });
    });
  });
  _defineProperty(this, "onAdditionalDetails", function (state) {
    _this.document.querySelector('#additionalDetailsHidden').value = JSON.stringify(_objectSpread(_objectSpread({}, state.data), {}, {
      paymentData: {}
    }));
    _this.document.querySelector('#showConfirmationForm').submit();
  });
  // BYL: the sheet must always get an answer. A throw in here -- including
  // one from actions.reject itself -- leaves Google waiting until it gives up
  // with CALLBACK_TIMED_OUT, hiding the real cause.
  _defineProperty(this, "onAuthorized", function (data, actions) {
    var settle = function (name) {
      try {
        if (actions && typeof actions[name] === 'function') {
          actions[name]();
          return true;
        }
        // eslint-disable-next-line no-console
        console.error('[GooglePayExpress] onAuthorized: actions.' + name + ' is not callable');
      } catch (settleError) {
        // eslint-disable-next-line no-console
        console.error('[GooglePayExpress] onAuthorized: actions.' + name + ' threw', settleError);
      }
      return false;
    };
    var authorizedEvent = data && data.authorizedEvent ? data.authorizedEvent : data;
    try {
      _this.customer = GooglePay.formatCustomerObject(authorizedEvent);
      settle('resolve');
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('[GooglePayExpress] onAuthorized failed', GooglePay.describeAuthorizedEvent(authorizedEvent), error);
      settle('reject');
    }
  });
  _defineProperty(this, "callPaymentFromComponent", function (data) {
    return httpClient({
      url: _this.paymentFromComponentURL,
      method: 'POST',
      data: {
        data: JSON.stringify(data),
        paymentMethod: GOOGLE_PAY
      }
    });
  });
  _defineProperty(this, "onSubmit", /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(state, component, actions) {
      var _response$fullRespons, stateData, response, _t;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.p = _context6.n) {
          case 0:
            _context6.p = 0;
            $.spinner().start();
            stateData = _objectSpread(_objectSpread({}, state.data), {}, {
              paymentType: 'express'
            });
            _context6.n = 1;
            return _this.callPaymentFromComponent(_objectSpread(_objectSpread({}, stateData), {}, {
              customer: _this.customer,
              isExpressPdp: _this.isExpressPdp
            }));
          case 1:
            response = _context6.v;
            if (!(response !== null && response !== void 0 && response.resultCode)) {
              GooglePay.stopSpinner();
              GooglePay.rejectPayment(actions.reject, response && response.errorMessage);
              return _context6.a(2);
            }
            helpers.createShowConfirmationForm(_this.showConfirmationAction);
            if (_this.isExpressPdp) {
              _this.helpers.setExpressRedirectUrl();
            }
            helpers.setOrderFormData(response);
            document.querySelector('#additionalDetailsHidden').value = JSON.stringify(_objectSpread(_objectSpread({}, stateData), response));
            actions.resolve({
              resultCode: response === null || response === void 0 ? void 0 : response.resultCode,
              action: response === null || response === void 0 ? void 0 : (_response$fullRespons = response.fullResponse) === null || _response$fullRespons === void 0 ? void 0 : _response$fullRespons.action
            });
            if ((response === null || response === void 0 ? void 0 : response.resultCode) === 'Authorised') {
              GooglePay.submitSuccessForm(response);
            }
            GooglePay.stopSpinner();
            _context6.n = 3;
            break;
          case 2:
            _context6.p = 2;
            _t = _context6.v;
            GooglePay.stopSpinner();
            GooglePay.rejectPayment(actions.reject);
          case 3:
            return _context6.a(2);
        }
      }, _callee6, null, [[0, 2]]);
    }));
    return function (_x8, _x9, _x0) {
      return _ref7.apply(this, arguments);
    };
  }());
  // BYL: Google Pay aborts the sheet with CALLBACK_TIMED_OUT when this
  // callback neither resolves in time nor at all -- a rejected promise never
  // reaches Google. Always resolve, fall back to a shipping error, and bound
  // the wait so a slow instance shows a message instead of hanging.
  _defineProperty(this, "resolvePaymentDataUpdate", function (intermediatePaymentData) {
    var data = intermediatePaymentData || {};
    var callbackTrigger = data.callbackTrigger,
      shippingAddress = data.shippingAddress,
      shippingOptionData = data.shippingOptionData;
    if (callbackTrigger === GOOGLE_PAY_CALLBACK_TRIGGERS.INITIALIZE) {
      return Promise.resolve(_this.isExpressPdp ? createTemporaryBasket() : null).then(function () {
        return _this.onShippingAddressChange(shippingAddress);
      });
    }
    if (callbackTrigger === GOOGLE_PAY_CALLBACK_TRIGGERS.SHIPPING_ADDRESS) {
      return Promise.resolve(_this.onShippingAddressChange(shippingAddress));
    }
    if (callbackTrigger === GOOGLE_PAY_CALLBACK_TRIGGERS.SHIPPING_OPTION) {
      return Promise.resolve(_this.onShippingOptionChange(shippingAddress, shippingOptionData));
    }
    // Google gets an empty update for anything we don't handle, which looks
    // identical to a hang from the outside. Say so.
    // eslint-disable-next-line no-console
    console.error('[GooglePayExpress] unhandled callback trigger', callbackTrigger);
    return Promise.resolve({});
  });
  _defineProperty(this, "onPaymentDataChanged", function (intermediatePaymentData) {
    var startedAt = new Date().getTime();
    _this.callTimings = [];
    var intent = intermediatePaymentData && intermediatePaymentData.callbackTrigger === GOOGLE_PAY_CALLBACK_TRIGGERS.SHIPPING_OPTION ? 'SHIPPING_OPTION' : 'SHIPPING_ADDRESS';
    var fallback = function (error) {
      // eslint-disable-next-line no-console
      console.error('[GooglePayExpress] shipping callback failed after', new Date().getTime() - startedAt, 'ms', intermediatePaymentData && intermediatePaymentData.callbackTrigger, _this.callTimings.join(' | '), error);
      return _this.unserviceable(intent);
    };
    // The timer keeps running after the race is decided, so it must stay quiet
    // once the callback has answered -- otherwise every successful callback
    // reports a bogus timeout once the deadline elapses.
    var settled = false;
    var deadline = new Promise(function (resolve) {
      setTimeout(function () {
        if (settled) {
          return;
        }
        settled = true;
        resolve(fallback(new Error('shipping callback exceeded ' + SHIPPING_CALLBACK_DEADLINE_MS + 'ms')));
      }, SHIPPING_CALLBACK_DEADLINE_MS);
    });
    var update;
    try {
      update = _this.resolvePaymentDataUpdate(intermediatePaymentData).then(function (paymentDataRequestUpdate) {
        settled = true;
        return paymentDataRequestUpdate;
      }, function (error) {
        settled = true;
        return fallback(error);
      });
    } catch (error) {
      settled = true;
      update = Promise.resolve(fallback(error));
    }
    return Promise.race([update, deadline]);
  });
  _defineProperty(this, "getConfig", function () {
    return {
      showPayButton: _this.showPayButton,
      isExpress: _this.isExpress,
      buttonType: 'buy',
      // BYL: fully rounded, to match the cart/minicart checkout CTA. 20px is
      // half of the 40px height forced in app_byl_core _minicart.scss; Google
      // applies the value verbatim (no clamping).
      buttonRadius: 20,
      emailRequired: true,
      shippingAddressRequired: true,
      shippingOptionRequired: true,
      shippingAddressParameters: {
        allowedCountryCodes: window.allowedShippingCountries && window.allowedShippingCountries.length ? window.allowedShippingCountries : [window.countryCode],
        phoneNumberRequired: true
      },
      billingAddressRequired: true,
      billingAddressParameters: {
        format: 'FULL',
        phoneNumberRequired: true
      },
      gatewayMerchantId: window.merchantAccount,
      configuration: _this.config,
      callbackIntents: ['SHIPPING_ADDRESS', 'SHIPPING_OPTION'],
      amount: _this.amount,
      onAdditionalDetails: _this.onAdditionalDetails,
      onAuthorized: _this.onAuthorized,
      onSubmit: _this.onSubmit,
      paymentDataCallbacks: {
        onPaymentDataChanged: _this.onPaymentDataChanged
      }
    };
  });
  _defineProperty(this, "getComponent", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
    var checkout, googlePayConfig;
    return _regenerator().w(function (_context8) {
      while (1) switch (_context8.n) {
        case 0:
          _context8.n = 1;
          return initializeCheckout(_this.applicationInfo, _this.translations);
        case 1:
          checkout = _context8.v;
          googlePayConfig = _this.getConfig();
          return _context8.a(2, window.AdyenWeb.createComponent(GOOGLE_PAY, checkout, googlePayConfig));
      }
    }, _callee8);
  })));
  var _window = window,
    basketAmount = _window.basketAmount,
    showConfirmationAction = _window.showConfirmationAction,
    shippingMethodsUrl = _window.shippingMethodsUrl,
    selectShippingMethodUrl = _window.selectShippingMethodUrl,
    paymentFromComponentURL = _window.paymentFromComponentURL;
  this.store = store;
  this.helpers = helpers;
  this.amount = initialAmount || JSON.parse(basketAmount);
  this.showPayButton = true;
  this.isExpress = true;
  this.isExpressPdp = isExpressPdp;
  this.paymentFromComponentURL = paymentFromComponentURL;
  this.showConfirmationAction = showConfirmationAction;
  this.shippingMethodsUrl = shippingMethodsUrl;
  this.selectShippingMethodUrl = selectShippingMethodUrl;
  this.applicationInfo = applicationInfo;
  this.translations = adyenTranslations;
  this.config = config;
  this.document = document;
  this.callTimings = [];
});
_defineProperty(GooglePay, "formatCustomerObject", function (customerData) {
  var shippingData = customerData.shippingAddress;
  var billingData = customerData.paymentMethodData.info.billingAddress;
  var nameParts = customerData.shippingAddress.name.split(' ');
  var firstName = nameParts[0];
  var lastName = nameParts.length > 1 ? nameParts.slice(1).join(' ') : ''; // Join the rest
  return {
    addressBook: {
      addresses: {},
      preferredAddress: {
        address1: shippingData.address1,
        address2: shippingData.address2 ? shippingData.address2 : null,
        city: shippingData.locality,
        countryCode: {
          displayValue: shippingData.countryCode,
          value: shippingData.countryCode
        },
        firstName: firstName,
        lastName: lastName,
        ID: customerData.email,
        postalCode: shippingData.postalCode,
        stateCode: shippingData.administrativeArea
      }
    },
    billingAddressDetails: {
      address1: billingData.address1,
      address2: billingData.address2 ? billingData.address2 : null,
      city: billingData.locality,
      countryCode: {
        displayValue: billingData.countryCode,
        value: billingData.countryCode
      },
      firstName: firstName,
      lastName: lastName,
      postalCode: billingData.postalCode,
      stateCode: billingData.administrativeArea
    },
    customer: {},
    profile: {
      firstName: firstName,
      lastName: lastName,
      email: customerData.email,
      phone: shippingData.phoneNumber
    }
  };
});
// BYL: shape report for the Google Pay authorization payload. Field presence
// only, never values -- the payload carries the shopper's address and email.
_defineProperty(GooglePay, "describeAuthorizedEvent", function (authorizedEvent) {
  var event = authorizedEvent || {};
  var paymentMethodData = event.paymentMethodData || {};
  var info = paymentMethodData.info || {};
  var shippingAddress = event.shippingAddress || {};
  return {
    keys: Object.keys(event),
    hasEmail: !!event.email,
    hasShippingAddress: !!event.shippingAddress,
    hasShippingName: !!shippingAddress.name,
    hasPaymentMethodData: !!event.paymentMethodData,
    hasInfo: !!paymentMethodData.info,
    hasBillingAddress: !!info.billingAddress
  };
});
// BYL: the locale is not always a string -- CartModel carries none at all, so
// this countryCode used to be undefined on every update. Never let it throw.
_defineProperty(GooglePay, "getCountryCodeFromLocale", function (locale) {
  if (typeof locale === 'string' && locale.length >= 2) {
    return locale.slice(-2).toUpperCase();
  }
  return window.countryCode;
});
_defineProperty(GooglePay, "getTransactionInfo", function (newCalculation) {
  var _newCalculation$grand, _newCalculation$grand2;
  return {
    countryCode: GooglePay.getCountryCodeFromLocale(newCalculation && newCalculation.locale),
    currencyCode: newCalculation === null || newCalculation === void 0 ? void 0 : (_newCalculation$grand = newCalculation.grandTotalAmount) === null || _newCalculation$grand === void 0 ? void 0 : _newCalculation$grand.currency,
    totalPriceStatus: 'FINAL',
    totalPriceLabel: 'Total',
    totalPrice: "".concat(newCalculation === null || newCalculation === void 0 ? void 0 : (_newCalculation$grand2 = newCalculation.grandTotalAmount) === null || _newCalculation$grand2 === void 0 ? void 0 : _newCalculation$grand2.value)
  };
});
_defineProperty(GooglePay, "getBaseTransactionInfo", function (amount) {
  var fractionDigits = parseInt(window.fractionDigits, 10);
  if (isNaN(fractionDigits)) {
    fractionDigits = 2;
  }
  var value = amount && amount.value ? amount.value : 0;
  return {
    countryCode: window.countryCode,
    currencyCode: amount && amount.currency,
    totalPriceStatus: 'FINAL',
    totalPriceLabel: 'Total',
    totalPrice: (value / Math.pow(10, fractionDigits)).toFixed(fractionDigits)
  };
});
// BYL: the cart renders the button into #express-container and the PDP into
// #express-payment-buttons, so look the text up by its attribute rather than by
// container id -- otherwise the PDP flow falls back to English.
_defineProperty(GooglePay, "getUnserviceableMessage", function () {
  var container = document.querySelector('[data-unserviceable-message]');
  var message = container && container.dataset ? container.dataset.unserviceableMessage : '';
  return message || 'Cannot ship to the selected address';
});
// BYL: Google rejects the whole update -- closing the sheet with no error of
// its own -- when an option carries a non-string description, and a shipping
// method without a description sends null. Omit the key instead.
_defineProperty(GooglePay, "getShippingOptionsParameters", function (selectedShippingMethod, shippingMethodsData) {
  return {
    defaultSelectedOptionId: selectedShippingMethod.ID,
    shippingOptions: shippingMethodsData.shippingMethods.map(function (sm) {
      var option = {
        label: sm.displayName || sm.ID,
        id: sm.ID
      };
      if (typeof sm.description === 'string' && sm.description) {
        option.description = sm.description;
      }
      return option;
    })
  };
});
_defineProperty(GooglePay, "submitSuccessForm", function (response) {
  var _document$querySelect;
  if (document.querySelector('#result')) {
    var _response$fullRespons2, _response$fullRespons3, _response$fullRespons4, _response$fullRespons5, _response$fullRespons6, _response$fullRespons7, _response$fullRespons8;
    document.querySelector('#result').value = JSON.stringify({
      pspReference: (_response$fullRespons2 = response.fullResponse) === null || _response$fullRespons2 === void 0 ? void 0 : _response$fullRespons2.pspReference,
      resultCode: (_response$fullRespons3 = response.fullResponse) === null || _response$fullRespons3 === void 0 ? void 0 : _response$fullRespons3.resultCode,
      paymentMethod: (_response$fullRespons4 = response.fullResponse) !== null && _response$fullRespons4 !== void 0 && _response$fullRespons4.paymentMethod ? response.fullResponse.paymentMethod : (_response$fullRespons5 = response.fullResponse) === null || _response$fullRespons5 === void 0 ? void 0 : (_response$fullRespons6 = _response$fullRespons5.additionalData) === null || _response$fullRespons6 === void 0 ? void 0 : _response$fullRespons6.paymentMethod,
      donationToken: (_response$fullRespons7 = response.fullResponse) === null || _response$fullRespons7 === void 0 ? void 0 : _response$fullRespons7.donationToken,
      amount: (_response$fullRespons8 = response.fullResponse) === null || _response$fullRespons8 === void 0 ? void 0 : _response$fullRespons8.amount
    });
  }
  (_document$querySelect = document.querySelector('#showConfirmationForm')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.submit();
});
// BYL: the sheet is still open when a payment is refused, so reject without
// navigating -- a ShowConfirmation submit behind the sheet kills the callbacks
// of any retry (SF-18491). Adyen hands a string googlePayError to Google as
// the message shown in the sheet.
_defineProperty(GooglePay, "rejectPayment", function (reject, message) {
  reject(message ? {
    error: {
      googlePayError: message
    }
  } : undefined);
});
_defineProperty(GooglePay, "stopSpinner", function () {
  var _$;
  if ((_$ = $) !== null && _$ !== void 0 && _$.spinner) {
    var spinnerFn = $.spinner();
    if (spinnerFn.stop) {
      var _$$spinner;
      (_$$spinner = $.spinner()) === null || _$$spinner === void 0 ? void 0 : _$$spinner.stop();
    }
  }
});
module.exports = GooglePay;
